// services/loginApi.js
import apiClient from './apiClient';
const authApi = apiClient('auth');

const loginApi = {
    telegramInit: async (initData) => {
        return (await authApi.post('/telegram', { initData })).data;
    },
    me: async () => (await authApi.get('/me')).data,
};

export default loginApi;
